<template>
    <div id="app">
        <div class="wrapper">
            <div class="wrapper-in">
                <main class="content">
                    <home></home>
                </main>
            </div>
        </div>
    </div>
</template>

<script>
    import home from '@/views/home.vue'
    export default {
        components: {
            home,
        },
        data () {
            return {
            }
        },
        computed: {
        },
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        destroyed() {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/main.scss';
</style>